import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import type { IMetricCardSecondaryProps } from "./types";

export const MetricCardSecondary = ({ caption, benchmark }: IMetricCardSecondaryProps) => {
    const translate = useTranslation();

    if (!caption && !benchmark) {
        return null;
    }

    return (
        <Stack gap="2px">
            {caption ? (
                <Text fontVariant="caption">
                    {translate(caption.textKey, {
                        brand: caption.brand,
                        mentions: (caption.mentions ?? 0).toLocaleString(),
                        total: (caption.total ?? 0).toLocaleString(),
                    })}
                </Text>
            ) : null}
            {benchmark}
        </Stack>
    );
};
